import { html } from "@microsoft/fast-element";
/**
 * The template for the {@link @microsoft/fast-foundation#Card} component.
 * @public
 */
export const CardTemplate = html `
    <slot></slot>
`;
